import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {RequestServiceProvider} from "../../providers/request-service/request-service";
import {TransactionAlertProvider} from "../../providers/transaction-alert/transaction-alert";

/**
 * Generated class for the PendingTransactionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pending-transaction',
  templateUrl: 'pending-transaction.html',
})
export class PendingTransactionPage {

  loading: Boolean = false;
  transactions: Array<Object> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private request: RequestServiceProvider, private transAlert: TransactionAlertProvider) {

  }



  naira(number) {
    return Number(number || 0 ).toLocaleString("en-NG", {
      currency: "NGN",
      currencyDisplay: "symbol",
      style: "currency"
    });
  }

  ionViewWillLoad() {
    this.request.getPendingTransactions().subscribe(
      data => {
        this.transactions = data;
        this.loading = false;
      },
      error => {
        if (error.json().code === 403 || error.code === 403 ) {
          this.request.logout();
        }else {
          this.transAlert.presentNormalErrorAlert(error.message);
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/pending-transaction/pending-transaction.ts